import { lazyWithPreload } from 'helpers/lazyWithPreload'

export const ScannerFeedback = lazyWithPreload(
  () => import('./ScannerFeedback'),
)
